import type { AssetStoryblok } from '@/storyblok/wirfuersklima/types';

export function nl2br(str: string, replaceMode: boolean, isXhtml: boolean): string {
  const breakTag = isXhtml ? '<br />' : '<br>';
  const replaceStr = replaceMode ? '$1' + breakTag : '$1' + breakTag + '$2';
  return (str + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, replaceStr);
}

export function imageMeta(media: AssetStoryblok): { width: number; height: number } {
  if (!media.filename) {
    return { width: 0, height: 0 };
  }

  const w = media.filename.split('/')[5]?.split('x')[0] || '0';
  const h = media.filename.split('/')[5]?.split('x')[1] || '0';

  return {
    width: parseInt(w, 10),
    height: parseInt(h, 10),
  };
}
